const propertyReportMge = r => require.ensure([], () => r(require('@/page/propertyReportMge/propertyReportMge')), 'propertyReportMge');
const formulateReport = r => require.ensure([], () => r(require('@/page/propertyReportMge/formulateReport/formulateReport')), 'formulateReport');
const propertyDeclare = r => require.ensure([], () => r(require('@/page/propertyReportMge/propertyDeclare/propertyDeclare')), 'propertyDeclare');
const propertyDeclareAdd = r => require.ensure([], () => r(require('@/page/propertyReportMge/propertyDeclare/propertyDeclareAdd')), 'propertyDeclareAdd');
const changeReport = r => require.ensure([], () => r(require('@/page/propertyReportMge/propertyDeclare/changeReport')), 'changeReport');
const whiteList = r => require.ensure([], () => r(require('@/page/propertyReportMge/propertyDeclare/whiteList')), 'whiteList');

const propertyDeclareList = r => require.ensure([], () => r(require('@/page/propertyReportMge/propertyDeclare/propertyDeclareList')), 'propertyDeclareList');
const propertyDeclareFill = r => require.ensure([], () => r(require('@/page/propertyReportMge/propertyDeclare/propertyDeclareFill')), 'propertyDeclareFill');
// const propertyDeclareFillNew = r => require.ensure([], () => r(require('@/page/propertyReportMge/propertyDeclare/propertyDeclareFillNew')), 'propertyDeclareFillNew');
const InformationMaintenanceReport = r => require.ensure([], () => r(require('@/page/propertyReportMge/InformationMaintenanceReport/InformationMaintenanceReport')), 'InformationMaintenanceReport');
const PropertyProjectInformationMaintenance = r => require.ensure([], () => r(require('@/page/propertyReportMge/PropertyProjectInformationMaintenance/PropertyProjectInformationMaintenance')), 'formulateReport');
const enterpriseInfoMaintain = r => require.ensure([], () => r(require('@/page/propertyReportMge/basicInfoMge/enterpriseInfoMge/enterpriseInfoMaintain')), 'enterpriseInfoMaintain');
const infoMaintainEdit = r => require.ensure([], () => r(require('@/page/propertyReportMge/basicInfoMge/enterpriseInfoMge/infoMaintainEdit')), 'infoMaintainEdit');
const ownersInfoMaintain = r => require.ensure([], () => r(require('@/page/propertyReportMge/basicInfoMge/ownersInfoMge/ownersInfoMaintain')), 'ownersInfoMaintain');
const ownersMaintainEdit = r => require.ensure([], () => r(require('@/page/propertyReportMge/basicInfoMge/ownersInfoMge/ownersMaintainEdit')), 'ownersMaintainEdit');
const ownersMaintainAdd = r => require.ensure([], () => r(require('@/page/propertyReportMge/basicInfoMge/ownersInfoMge/ownersMaintainAdd')), 'ownersMaintainAdd');
const AddPropertyProjectInformation = r => require.ensure([], () => r(require('@/page/propertyReportMge/AddPropertyProjectInformation/AddPropertyProjectInformation')), 'AddPropertyProjectInformation');
const EditMaintenanceInformation = r => require.ensure([], () => r(require('@/page/propertyReportMge/EditMaintenanceInformation/EditMaintenanceInformation')), 'EditMaintenanceInformation');
const ConstructionUnitInformationMaintenance = r => require.ensure([], () => r(require('@/page/propertyReportMge/ConstructionUnitInformationMaintenance/ConstructionUnitInformationMaintenance')), 'ConstructionUnitInformationMaintenance');
const EditInformationConstructionUnits = r => require.ensure([], () => r(require('@/page/propertyReportMge/EditInformationConstructionUnits/EditInformationConstructionUnits')), 'EditInformationConstructionUnits');
const AddInformationConstructionUnits = r => require.ensure([], () => r(require('@/page/propertyReportMge/AddInformationConstructionUnits/AddInformationConstructionUnits')), 'AddInformationConstructionUnits');
const ReportDictionaryData = r => require.ensure([], () => r(require('@/page/propertyReportMge/ReportDictionaryData/ReportDictionaryData')), 'ReportDictionaryData');
const ReportTemplate = r => require.ensure([], () => r(require('@/page/propertyReportMge/ReportDictionaryData/ReportTemplate')), 'ReportTemplate');

const propertyReportFillNew = r => require.ensure([], () => r(require('@/page/propertyReportMge/propertyDeclare/propertyReportFillNew')), 'propertyReportFillNew');
const newReportFill = r => require.ensure([], () => r(require('@/page/propertyReportMge/propertyDeclare/newReportFill')), 'newReportFill');

const propertyReportRouter = {
  path: '',
  component: propertyReportMge,
  meta: {
    icon: 'publicFundManagement',
    right: [],
    isShowMenu: true,
    keepAlive:true
  },
  name: '企业报表管理',
  children: [{
    path: '/formulateReport',
    component: formulateReport,
    name: '制定报表阶段',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive:true,
    },
  }, {
    path: '/ReportDictionaryData',
    component: ReportDictionaryData,
    name: '报表字典数据',
    meta: {
      right: [],
      isShowMenu: false,
      keepAlive:true,
    },
  },
  {
    path: '/ReportTemplate',
    component: ReportTemplate,
    name: '报表模板',
    meta: {
      right: [],
      isShowMenu: false,
      keepAlive:true,
    },
  }, {
    path: '/propertyDeclareAdd',
    component: propertyDeclareAdd,
    name: '物业申报解锁',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive:false,
    },
  }, {
    path: '/changeReport',
    component: changeReport,
    name: '制定报表阶段',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive:true,
    },
  }, {
    path: '/whiteList',
    component: whiteList,
    name: '企业白名单',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive: false,
    },
  }, {
    path: '/propertyDeclareList',
    component: propertyDeclareList,
    name: '物业申报列表',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive:true,
    },
  },
  {
    path: '/propertyDeclare',
    component: propertyDeclare,
    name: '物业企业信息申报',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive:true,
    },
  },
  {
    path: '/propertyReportFillNew',
    component: propertyReportFillNew,
    name: '报表填报',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive:false,
    },
  }, 
  {
    path: '/newReportFill',
    component: newReportFill,
    name: '报表填报',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive:false,
    },
  }, 
  {
    path: '/InformationMaintenanceReport',
    component: InformationMaintenanceReport,
    name: '物业企业信息维护',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive:true,
    },
  }, {
    path: '/PropertyInformation',
    component: PropertyProjectInformationMaintenance,
    name: '物业项目信息维护',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive:true,
    },
  }, {
    path: '/AddPropertyProjectInformation',
    component: AddPropertyProjectInformation,
    name: '新增物业项目信息维护',
    meta: {
      right: [],
      isShowMenu: false,
      keepAlive:true,
    },
  },
  {
    path: '/EditMaintenanceInformation',
    component: EditMaintenanceInformation,
    name: '编辑物业项目信息维护',
    meta: {
      right: [],
      isShowMenu: false,
      keepAlive:true,
    },
  },
  {
    path: '/ConstructionUnitInformationMaintenance',
    component: ConstructionUnitInformationMaintenance,
    name: '建设单位信息维护',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive:true,
    },
  },
  {
    path: '/EditInformationConstructionUnits',
    component: EditInformationConstructionUnits,
    name: '编辑建设单位信息维护',
    meta: {
      right: [],
      isShowMenu: false,
      keepAlive:true,
    },
  },
  {
    path: '/AddInformationConstructionUnits',
    component: AddInformationConstructionUnits,
    name: '新增建设单位信息维护',
    meta: {
      right: [],
      isShowMenu: false,
      keepAlive:true,
    },
  },
  {
    path: '/enterpriseInfoMaintain',
    component: enterpriseInfoMaintain,
    name: '企业人员信息维护',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive:true,
    },
  },
  {
    path: '/infoMaintainEdit',
    component: infoMaintainEdit,
    name: '企业人员信息',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive:true,
    },
  },
  {
    path: '/ownersInfoMaintain',
    component: ownersInfoMaintain,
    name: '业主委员会信息维护',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive:true,
    },
  },
  {
    path: '/ownersMaintainEdit',
    component: ownersMaintainEdit,
    name: '修改业主委员会',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive:true,
    },
  }, {
    path: '/ownersMaintainAdd',
    component: ownersMaintainAdd,
    name: '新增业主委员会',
    meta: {
      right: [],
      isShowMenu: true,
      keepAlive:true,
    },
  },
  ]

};

export default propertyReportRouter;
